<template>
    <v-container>
        <h1 class="page-heading">Marketplace</h1>
        <router-link to="marketplace-highlights" v-if="userHasAccess">
            <p class="text-sm font-yellow">View Your Activities</p>
        </router-link>
    </v-container>
    <v-container v-if="!userHasAccess">
        <RequestAccess
            desc_text="Would you like to sell your solar energy on the Malaysian market?"
            button_text="Yes, install solar panels"
            alt_text="I already have solar panels"
            :feature_name="featureName"
        />
    </v-container>
    <v-container v-else>
        <MarketplaceHeader
            @change-to-leaderboard="changeToLeaderboard"
            @change-to-listing="changeToListing"
            @btn-click="toggleShowAddListing"
            :isOnListing="isOnListing"
            :listings="listings"
            :showAddListing="showAddListing"
        />
        <MarketplaceAddListing
            @add-listing="addListing"
            v-show="showAddListing"
        />
        <div v-if="isOnListing">
            <MarketplaceListing
                :listings="listings"
                @buy-listing="buyListing"
            />
        </div>
        <div v-else>
            <MarketplaceLeaderboard />
        </div>
    </v-container>
</template>

<script>
import MarketplaceHeader from "../components/MarketplaceHeader";
import MarketplaceListing from "../components/MarketplaceListing";
import MarketplaceLeaderboard from "../components/MarketplaceLeaderboard";
import MarketplaceAddListing from "../components/MarketplaceAddListing";
import RequestAccess from "../components/RequestAccess.vue";
import store from "@/store";
import { computed } from "vue";
import {
    collection,
    getFirestore,
    getDocs,
    setDoc,
    doc,
    query,
    where,
    Timestamp,
} from "firebase/firestore";
export default {
    name: "MarketplaceView",
    data() {
        return {
            isOnListing: true,
            listings: Array,
            showAddListing: false,
            db: getFirestore(),
        };
    },
    components: {
        MarketplaceHeader,
        MarketplaceListing,
        MarketplaceLeaderboard,
        MarketplaceAddListing,
        RequestAccess,
    },
    methods: {
        changeToLeaderboard() {
            this.isOnListing = false;
            this.showAddListing = false;
        },
        changeToListing() {
            this.isOnListing = true;
        },
        addListing(newListing) {
            this.listings.push(newListing);
            this.showAddListing = false;
        },
        toggleShowAddListing() {
            this.showAddListing = !this.showAddListing;
        },
        getAllListings() {
            this.listings = [];
            const q = query(
                collection(this.db, "listings"),
                where("status", "==", "Active")
            );
            getDocs(q)
                .then((res) => {
                    if (res != undefined) {
                        res.docs.forEach((doc) =>
                            this.listings.push(doc.data())
                        );
                    }
                })
                .catch((e) => console.log(e));
        },
        buyListing(listingID) {
            setDoc(
                doc(this.db, "listings", listingID),
                {
                    status: "Sold",
                    buyer_id: store.state.user?.user_id,
                    buy_date: Timestamp.fromDate(new Date()),
                },
                { merge: true }
            )
                .then(() => this.getAllListings())
                .catch((e) => console.log(e));
        },
    },
    created() {
        this.getAllListings();
    },
    setup() {
        const featureName = "Marketplace";
        const userHasAccess = computed(
            () => store.state.user?.features?.includes(featureName) || false
        );
        return {
            featureName,
            userHasAccess,
        };
    },
};
</script>

<style lang="scss">
h1 {
    font-size: 50px;
    color: $black;
}
</style>
